import React, { useEffect, useRef } from 'react';
import { UserCard } from 'react-ui-cards';
import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { FaGithub, FaFacebook, FaTwitter, FaLinkedin, FaUser } from 'react-icons/fa';
import { BASE_URL } from '../settings';

export default function UserProfileCard({ alumni }) {
    let { uuid, avatar, username, firstName, lastName, positionName, classYear } = alumni;
    const navigate = useNavigate();

    // handler to generate a random id
    const randomId = () => Math.random().toString(36).slice(1) + Date.now();

    const stats = [];
    if (alumni?.githubLink !== null) {
        stats.push({
            name: (
                <FaGithub
                    color='black'
                    className='profile-card-icon'
                    size={20}
                    onClick={() => navigate(alumni?.githubLink)}
                />
            ),
            id: randomId(),
        });
    }
    if (alumni?.facebookLink !== null) {
        stats.push({
            name: (
                <FaFacebook
                    color='darkblue'
                    className='profile-card-icon'
                    size={20}
                    onClick={() => navigate(alumni?.facebookLink)}
                />
            ),
            id: randomId(),
        });
    }
    if (alumni?.twitterLink !== null) {
        stats.push({
            name: (
                <FaTwitter
                    color='blue'
                    className='profile-card-icon'
                    size={20}
                    onClick={() => navigate(alumni?.twitterLink)}
                />
            ),
            id: randomId(),
        });
    }
    if (alumni?.linkedInLink !== null) {
        stats.push({
            name: (
                <FaLinkedin
                    color='blue'
                    className='profile-card-icon'
                    size={20}
                    onClick={() => navigate(alumni?.linkedInLink)}
                />
            ),
            id: randomId(),
        });
    }

    const handleUserProfileCardPressed = () => {
        navigate(`/alumni/classes/${classYear}/${uuid}`, {
            state: { alumni },
        });
    };

    return (
        <div className='user-profile-card-container' style={{ cursor: 'pointer' }}>
            <UserCard
                float
                onClick={handleUserProfileCardPressed}
                header={require('../images/admin.jpg')}
                avatar={
                    avatar
                        ? `${BASE_URL}/alumni/uploads/get-profile-pic/${avatar}`
                        : require('../images/profile-pictures/face1.jpg')
                }
                // name={firstName + ' ' + lastName?.slice(0, 26)}
                name={
                    <p>
                        {firstName + ' ' + lastName?.slice(0, 26)}
                        <br />
                        <span style={{ fontSize: '1rem', marginLeft: '1rem' }}>
                            @{username?.slice(0, 20)}
                        </span>
                    </p>
                }
                positionName={positionName?.slice(0, 26)}
                // stats={stats}
                className='user-profile-card'
            />
        </div>
    );
}
